import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { ElectionContact, ElectionContext, Round } from 'src/app/pap-creation/pap-dto/pap-dto';
@Component({
  selector: 'app-poll-creation-sender',
  templateUrl: 'poll-creation-sender.component.html',
  styleUrls: ['./poll-creation-sender.component.less', '../../../shared/common.less'],
})

export class PollCreationSenderComponent implements OnInit {
  @Input() sender: string;
  @Input() electionImage: string;
  @Input() draftId: string;
  @Output() senderChange = new EventEmitter<string>();
  @Output() imageChange = new EventEmitter<{ imageBlob: Blob, extensionImage: string }>();
  displayImageError: boolean = false;

  constructor() { }

  onFileChanged(event) {
    const displayImage = document.getElementById('uploaded') as HTMLImageElement;
    const uploadImage = document.getElementById('upload-image-icon') as HTMLImageElement;
    const uploadDescription = document.getElementById('description-upload');
    const uploadedImagePanel = document.getElementById('upload-image-wrapper');
    const uploadImagePanel = document.getElementById('upload-panel');
    //this.imageName = document.getElementById('image-name');

    const reader = new FileReader();
    const extensionImage = event[0].name.substring(event[0].name.lastIndexOf('.'));

    const imageBlob = new Blob(event);

    reader.readAsDataURL(imageBlob);
    if (event[0].size > 2097152) {
      this.displayImageError = true;
    }


    const image = new Image();
    const objectUrl = URL.createObjectURL(event[0]);
    image.onload = function () {
      //if (this.displayImageError === false) {
      displayImage.style.display = 'block';
      displayImage.src = URL.createObjectURL(imageBlob);
      uploadImage.style.display = 'none';
      /*uploadedImagePanel.style.display = 'grid';
      uploadImagePanel.style.display = 'none';
      uploadDescription.style.display = 'none';
      this.imageName.style.display = 'block';*/

      //this.onUnionImageChange.emit([extensionImage, imageBlob]);

      // this.sendPollImage.emit([extensionImage, imageBlob]);
      // }
      URL.revokeObjectURL(objectUrl);
      //this.uploadUnionImage(imageBlob, extensionImage);
      this.imageChange.emit({ imageBlob, extensionImage });

    }.bind(this, event);
    image.src = objectUrl;
  }

  ngOnInit(): void {
  }
}
